<template>
  <div>
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" layout='inline' :onFinish='pageSearchChange'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" placeholder="请输入标题进行搜索" :style="{'width':'270px'}" />
      </a-form-item>
      <a-form-item label="状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button class="m-r-10" type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a-button type="link" v-has:miniTemplateStatus="()=>miniTemplateDisable(record)">{{record.status?'禁用':'启用'}}</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </div>
</template>

<script>
  import { inject, reactive, ref, toRefs } from "vue";
  import { getSmsSubscribeList,smsSubscribeStatus } from "@/api/message.js";
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    keyword: '',
    status:''
  };
  export default {
    components: {  },
    setup() {
       //初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total:0
      })
      let columns = [
        {
          title: "消息应用",
          dataIndex: "send_business_text",
          key: "send_business_text",
        },
        {
          title: "模板名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "触发条件",
          dataIndex: "trigger_condition",
          key: "trigger_condition",
          customRender:({record})=>{
            return record.trigger_condition?record.trigger_condition:'-'
          },
        },
        {
          title: "模板内容",
          dataIndex: "content",
          key: "content",
        },
        {
          title: "状态",
          dataIndex: "status",
          key: "status",
          customRender:({record})=>{
            return record.status?'启用':'禁用'
          },
          width:100
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
          width:100
        }
      ];
      const $Modal = inject('$Modal')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        data.value=[];
        state.listLoading = true;
        let res = await getSmsSubscribeList(values).then((res) => res.data);
        if (iscode(res)) {
          data.value = res.data.data
          state.total = res.data.total
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      initData(search.value)
      // 修改状态
      const miniTemplateDisable = (e) => {
        console.log(e)
        $Modal.confirm({
          centered: true,
          content: `确定要${e.status ? '禁用' : '启用'}该模板么`, onOk: async () => {
            let res = await smsSubscribeStatus(e.id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      return {
        search,
        columns,
        pageCurrentChange,
        pageSizeChange,
        pageSearchChange,
        data,
        ...toRefs(state),
        miniTemplateDisable,
      };
    },
  };
</script>